import React from "react";
import { useSelector, useDispatch } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { fetchKeycloakUserId } from "../../../Redux/Actions/keyCloakAction";
import SimpleReactValidator from "simple-react-validator";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { getKeyCloakToken } from "../../../Redux/Actions/keyCloakAction";
import { isValidHttpUrl } from "../../../Utils/http";
import { Text } from "react-internationalization";
const KeyCloakLogin = () => {
  const [state, setState] = React.useState({
    email: "",
    snackBarOpen: false,
    vertical: "top",
    horizontal: "center",
    snackBarSeverty: "",
    snackBarMsg: "",
  });
  const { customerId, subDomain } = useSelector((st) => st.login);
  const dispatch = useDispatch();
  const setSnackBar = (msg, type) => {
    setState({
      ...state,
      snackBarOpen: true,
      snackBarMsg: msg,
      snackBarSeverty: type,
    });
  };
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const agentLogin = async (e) => {
    e.preventDefault();
    if (!validator.check(email, "email") || customerId === "") {
      setSnackBar("User credentials is not valid.", "error");
    } else {
      //const response = await dispatch(getKeyCloakToken());
      // console.log("response..", response);
      const resp = await dispatch(
        fetchKeycloakUserId({ emailAddress: email, customerId })
      );

      // console.log("user---", resp);
      if (resp.status == "OK") {
        if (
          window.sessionStorage.getItem("isDeeplink") &&
          window.sessionStorage.getItem("isDeepEmail") === email
        ) {
          const isValidSessionURL = isValidHttpUrl(
            window.sessionStorage.getItem("isDeeplink")
          );
          if (isValidSessionURL) {
            const isValidSubDomainURL = `${isValidHttpUrl(
              subDomain
            )}/auth-api/login?redirectUrl=${window.btoa(
              isValidSessionURL
            )}&login_hint=${resp.data.userId}`;
            const isValidURl = isValidHttpUrl(isValidSubDomainURL);
            window.location.href = isValidURl;
          }
        } else {
          if (resp.data.isSSOUser === "Y") {
            setSnackBar(
              "You're not authorized to access the application. Please connect with admin for the access.",
              "error"
            );
          } else {
            //console.log(window.location.host);
            window.sessionStorage.removeItem("isDeeplink");

            const isValidSubDomainURL = `${isValidHttpUrl(
              subDomain
            )}auth-api/login?redirectUrl=${window.btoa(
              `${isValidHttpUrl(subDomain)}e-Enroll/dashboard`
            )}&login_hint=${resp.data.userId}`;

            // const isValidSubDomainURL = `${isValidHttpUrl(
            //   subDomain
            // )}auth-api/login?redirectUrl=${window.btoa(
            //   `${isValidHttpUrl(
            //     "http://mcr-vdi143.mcr.ifox.loc:3009/"
            //   )}e-Enroll/dashboard`
            // )}&login_hint=${resp.data.userId}`;

            if (isValidHttpUrl(isValidSubDomainURL)) {
              window.location.href = isValidHttpUrl(isValidSubDomainURL).href;
            }
          }
        }
      } else {
        setSnackBar("User credentials is not valid", "error");
      }
    }
  };
  const validator = new SimpleReactValidator();
  const {
    email,
    snackBarOpen,
    vertical,
    horizontal,
    snackBarSeverty,
    snackBarMsg,
  } = state;
  return (
    <form id="keycloakLogin" autoComplete="off">
      <div class=" mt-3 mg-footer-small">
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={6000}
          onClose={() => setState({ ...state, snackBarOpen: false })}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert
            onClose={() => setState({ ...state, snackBarOpen: false })}
            severity={snackBarSeverty}
          >
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <div class="container-Cambia form-panel">
          <div class="form-group1 row">
            <div class="col-md-12">
              <TextField
                label={<Text id="user.emailAdd" />}
                variant="outlined"
                type="email"
                name="email"
                fullWidth
                //error={emailError ? true : false}
                error={!validator.check(email, "email") || email === ""}
                className="agent-login-textfield"
                value={email}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    agentLogin(e);
                  }
                }}
                inputProps={{
                  autoComplete: "off",
                  spellcheck: "false",
                  "aria-autocomplete": "both",
                  "aria-haspopup": "false",
                }}
                //   onFocus={this.handleFocus("email")}
                //   onBlur={this.handleOnBlur("email")}
              />

              <br />
              <div class="position-relative">
                {/* <TextField
                  label="Customer Id*"
                  variant="outlined"
                  // type="email"
                  name="customerId"
                  fullWidth
                  //error={agentIDError ? true : false}
                  error={customerId === ""}
                  className="agent-login-textfield"
                  value={customerId}
                  disabled
                /> */}

                <div class="button-container-login-page text-right">
                  <button
                    type="button"
                    className="btn-primary-login"
                    id="signup"
                    onClick={(e) => agentLogin(e)}
                    // buttonLabel="Login"
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>{" "}
          </div>
          {/* </div> */}
        </div>
      </div>
    </form>
  );
};
export default KeyCloakLogin;
